import type { printOnDemand } from "common/utils/models";

/**
 * Transform numeric IDs to strings in print on demand product responses
 * This ensures consistent ID types throughout the application
 */
export function transformPrintOnDemandIds(
  response: printOnDemand.getProduct.Response | undefined
): printOnDemand.getProduct.Response | undefined {
  if (!response?.compositions) {
    return response;
  }

  return {
    ...response,
    compositions: response.compositions.map(comp => ({
      ...comp,
      id: String(comp.id),
      variants: comp.variants.map(variant => ({
        ...variant,
        id: String(variant.id),
        sku: variant.sku
      }))
    }))
  };
}

export function getRandomId() {
  try {
    return window.crypto.randomUUID();
  } catch (e) {
    window.Honeybadger?.notify("getRandomId error", {
      params: {
        error: e instanceof Error ? e.message : String(e),
        error_object: e instanceof Error ? e.toString() : String(e),
        stack_trace: e instanceof Error ? e.stack : null,
        function: "getRandomId"
      }
    });
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
      const r = Math.floor(Math.random() * 16);
      const v = c === "x" ? r : Math.floor(r % 4) + 8;
      return v.toString(16);
    });
  }
}

/**
 * Checks if the current URL is in edit mode.
 * @returns True if the current URL is in edit mode, false otherwise.
 */
export function isEditMode() {
  const searchParams = new URLSearchParams(window.location.search);
  const asgid = searchParams.get("asgid");
  const editParam = searchParams.get("edit");
  return editParam === "true" && !!asgid;
}
